import { useState } from "react";
import client, { getErrorMessage } from "@/api/client";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Small pop-up opened from the Vendor form's Bank Name dropdown ("Add new bank").
export default function AddBankDialog({ onClose, onAdded }) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!name.trim()) return setError("Bank Name is required");
    setSaving(true);
    try {
      const res = await client.post("/configurations/banks", { name: name.trim() });
      toast.success("Bank added");
      onAdded(res.data);
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-sm" data-testid="add-bank-dialog">
        <DialogHeader>
          <DialogTitle>Add new bank</DialogTitle>
        </DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <Input data-testid="add-bank-name-input" autoFocus placeholder="Bank Name" value={name} onChange={(e) => { setName(e.target.value); setError(""); }} />
          {error && <p className="text-xs text-red-600" data-testid="add-bank-error">{error}</p>}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} data-testid="add-bank-cancel-button">Cancel</Button>
            <Button type="submit" disabled={saving} data-testid="add-bank-save-button" className="bg-amber-600 hover:bg-amber-700">
              {saving ? "Saving..." : "Save"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
